import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../../../../src/app/core/services/navigation.service';
import { IspvisionService, VisionWs } from '../../../core/services/ispvision.service';
import { Router } from '@angular/router';

@Component({
    selector: 'start',
    templateUrl: './start.component.html',
    styleUrls: ['./start.component.less'],
})
export class StartComponent implements OnInit {
	private partitionToRoute: { [key: string]: string } = {
		'markiezen': 'markiezen',
		'kokers': 'kokers-en-profielen'
	};

    constructor(
        public navigation: NavigationService,
        private router: Router,
        public visionWs: IspvisionService
    ) {
        this.navigation.hideMenu = true;
    }

    async ngOnInit(): Promise<void> {
        this.visionWs.setFormPartitioning('markiezen');
        await this.visionWs.setUserFormPartitions();
        if (this.visionWs.userFormPartitions.length === 1) {
            this.navigateTo(`/${this.partitionToRoute[this.visionWs.userFormPartitions[0]]}`);
        }
    }

    public navigateTo(route: string): void {
        this.navigation.hideMenu = false;
        this.router.navigateByUrl(route + '/configurator');
    }
}
